import { Injectable, inject } from '@angular/core';
import {User} from '../models/user.model';
import { HttpClient } from '@angular/common/http';
import {Observable} from 'rxjs';
import {map, share} from 'rxjs/operators';
import {Store} from "@ngxs/store";
import {SessionState} from 'src/app/shared/state/session-state';

@Injectable({
  providedIn: 'root'
})
export class UserService {
  private http = inject(HttpClient);
  private store = inject(Store);


  /**
   * Fetch User Entity from server and cache locally
   * @returns {Observable<User>}
   */
  fetch(): Observable<User> {
    return this.http
      .get<User>('/api/user')
      .pipe(
        share()
      );
  }

  /**
   * Return true if user has the named role
   */
  public hasRole(roleName: string): Observable<boolean> {
    return this.store
      .select(SessionState.user)
      .pipe(
        map(user => {
          if (!user) {
            return false;
          }

          return user.roles.indexOf(roleName) > -1;
        })
      );
  }


  /**
   * Return true if user has the named role
   */
  public hasAbility(abilityName: string): Observable<boolean> {
    return this.store
      .select(SessionState.user)
      .pipe(
        map(user => {
          if (!user) {
            return false;
          }

          const found = user.abilities.find(ab => ab.name === abilityName || ab.name === '*');

          return !!found;
        })
      );
  }
}
